import { ReactText } from 'react';

export type DropdownFilterType = {
    selectedChannel?: string;
    selectedCampaign?: string;
};

export type SearchFilterType = {
    emailSearch?: string;
};

export type LastEventFilterType = {
    onlyLastEvent: boolean;
};

export type DateFilterType = {
    dateFilterValue?: ReactText;
};
export const DATE_FORMAT = 'YYYY-MM-DD';

export enum DateDropdownOptions {
    Calendar = 'calendar',
}

export const TIME_RANGE_1_DAY = 1;
export const LIMITED_LOGS_DAYS = 3;
export const TIME_RANGE_14_DAYS = 14;
export const LIMITED_LOGS_DAYS_PRO = 7;
export const EXTENDED_LOGS_DAYS = 35;

export const TIME_RANGES = [TIME_RANGE_1_DAY, LIMITED_LOGS_DAYS, TIME_RANGE_14_DAYS, LIMITED_LOGS_DAYS_PRO, EXTENDED_LOGS_DAYS];
